/**
 * Admin write schema for the app-level config (branding + theme + tax), the
 * counterpart to the read-only `GET /config`.
 *
 * Backed by AppConfigEntry rows. The key regex restricts writes to the
 * `branding.*`, `theme.*`, and `tax.*` namespaces so this endpoint can't
 * stomp limits/localization/feature keys. Values are arbitrary JSON
 * (e.g. `theme.colors.light` is an object, `tax.gstRatePercent` is a
 * number).
 */

import { z } from 'zod';

export const AppConfigEntrySchema = z.object({
  key: z
    .string()
    .regex(
      /^(branding|theme|tax)\.[a-z0-9_.]+$/iu,
      'Key must start with "branding.", "theme.", or "tax."',
    )
    .max(120),
  value: z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.record(z.string(), z.unknown()),
    z.array(z.unknown()),
  ]),
});
export type AppConfigEntry = z.infer<typeof AppConfigEntrySchema>;

export const UpdateAppConfigRequestSchema = z.object({
  entries: z.array(AppConfigEntrySchema).min(1).max(100),
});
export type UpdateAppConfigRequest = z.infer<typeof UpdateAppConfigRequestSchema>;
